import apiClient from "../apiClient";
const urlPath = "/api/users/me/";
/**
 * Hole alle Frames von der API.
 * @returns {Promise<Object>} Die Informationen des aktuellen Benutzers.
 */
export const fetchCurrentUser = async () => {
  const response = await apiClient.get(urlPath);
  console.info("Fetched current user:", response.data);
  return response.data; // Erwartet die Informationen des aktuellen Benutzers
};
